// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Yw1w","footer":"ChangeClinic_footer__mDePl"};